(function () {
  function parseConfig(finder) {
    var script = finder.querySelector('[data-tripak-finder-config]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function firstActiveButton(finder, group) {
    return finder.querySelector('[data-tripak-choice][data-choice-group="' + group + '"].is-active') || finder.querySelector('[data-tripak-choice][data-choice-group="' + group + '"]');
  }

  function setActiveButton(finder, button, makeLast) {
    var group = button.getAttribute('data-choice-group');
    if (!group) return;
    finder.querySelectorAll('[data-tripak-choice][data-choice-group="' + group + '"]').forEach(function (other) {
      other.classList.toggle('is-active', other === button);
    });
    finder.setAttribute('data-' + group, button.getAttribute('data-choice-value') || '');
    finder.setAttribute('data-' + group + '-rec-key', button.getAttribute('data-rec-key') || '');
    if (makeLast) finder.setAttribute('data-last-group', group);
  }

  function chooseRecommendationKey(finder, config) {
    var issueKey = finder.getAttribute('data-issue-rec-key') || '';
    var equipmentKey = finder.getAttribute('data-equipment-rec-key') || '';
    var fallback = config.default_rec_key || 'ldl1';

    var lastGroup = finder.getAttribute('data-last-group') || '';
    if (lastGroup === 'equipment' && equipmentKey && config.recommendations && config.recommendations[equipmentKey]) return equipmentKey;
    if (lastGroup === 'issue' && issueKey && config.recommendations && config.recommendations[issueKey]) return issueKey;
    if (issueKey && config.recommendations && config.recommendations[issueKey]) return issueKey;
    if (equipmentKey && config.recommendations && config.recommendations[equipmentKey]) return equipmentKey;
    if (config.recommendations && config.recommendations[fallback]) return fallback;

    var keys = Object.keys(config.recommendations || {});
    return keys.length ? keys[0] : '';
  }

  function renderRecommendation(finder) {
    var config = finder._tripakConfig || parseConfig(finder);
    finder._tripakConfig = config;

    var key = chooseRecommendationKey(finder, config);
    var rec = config.recommendations && config.recommendations[key] ? config.recommendations[key] : null;
    if (!rec) return;

    var title = finder.querySelector('[data-tripak-rec-title]');
    var label = finder.querySelector('[data-tripak-rec-label]');
    var text = finder.querySelector('[data-tripak-rec-text]');
    var bullets = finder.querySelector('[data-tripak-rec-bullets]');
    var productLink = finder.querySelector('[data-tripak-rec-product-link]');
    var wholesaleLink = finder.querySelector('[data-tripak-rec-wholesale-link]');
    if (title) title.textContent = rec.title || '';
    if (label) label.textContent = rec.label || '';
    if (text) text.textContent = rec.text || '';
    if (productLink) productLink.setAttribute('href', rec.url || config.fallback_product_url || '/collections/all');
    if (wholesaleLink) wholesaleLink.setAttribute('href', config.wholesale_url || '#');

    if (bullets) {
      bullets.innerHTML = '';
      (rec.bullets || []).filter(Boolean).forEach(function (item) {
        var div = document.createElement('div');
        var icon = document.createElement('span');
        var copy = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '✓';
        copy.textContent = item;
        div.appendChild(icon);
        div.appendChild(copy);
        bullets.appendChild(div);
      });
    }
  }

  function initFinder(finder) {
    if (!finder || finder.getAttribute('data-tripak-initialized') === 'true') return;
    finder.setAttribute('data-tripak-initialized', 'true');
    finder._tripakConfig = parseConfig(finder);

    ['equipment', 'issue'].forEach(function (group) {
      var active = firstActiveButton(finder, group);
      if (active) setActiveButton(finder, active, false);
    });

    finder.querySelectorAll('[data-tripak-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveButton(finder, btn, true);
        renderRecommendation(finder);
      });
    });

    renderRecommendation(finder);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-tripak-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });
})();
